if (!customElements.get('logo-list')) {
  class LogoList extends HTMLElement {
    constructor() {
      super();
      this.logoBar = this.querySelector('.logo-bar');
      this.speed = parseFloat(this.dataset.speed) || 5;
      this.direction = this.dataset.direction || 'left';
      this.isPaused = false;
      this.position = 0;
      this.animationId = null;
    }

    connectedCallback() {
      if (!this.logoBar) return;

      // Get the gap value from CSS
      const computedStyle = getComputedStyle(this.logoBar);
      this.gap = parseFloat(computedStyle.gap) || 100;

      // Clone the logo bar for seamless looping
      this.clonedBar = this.logoBar.cloneNode(true);
      this.clonedBar.setAttribute('aria-hidden', 'true');
      this.clonedBar.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
      this.appendChild(this.clonedBar);

      // Calculate total width including the gap between sets
      this.totalWidth = this.logoBar.offsetWidth + this.gap;

      // Start animation
      this.startAnimation();

      // Pause on hover
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());

      // Recalculate on resize
      window.addEventListener('resize', () => {
        this.totalWidth = this.logoBar.offsetWidth + this.gap;
      });
    }

    disconnectedCallback() {
      this.stopAnimation();
    }

    startAnimation() {
      const animate = () => {
        if (!this.isPaused) {
          const movement = this.speed * 0.5;

          if (this.direction === 'left') {
            this.position -= movement;
            if (Math.abs(this.position) >= this.totalWidth) {
              this.position = 0;
            }
          } else {
            this.position += movement;
            if (this.position >= this.totalWidth) {
              this.position = 0;
            }
          }

          this.style.transform = `translateX(${this.position}px)`;
        }
        this.animationId = requestAnimationFrame(animate);
      };

      this.animationId = requestAnimationFrame(animate);
    }

    stopAnimation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
    }

    pause() {
      this.isPaused = true;
    }

    resume() {
      this.isPaused = false;
    }
  }

  customElements.define('logo-list', LogoList);
}
